import React from "react";
import { Table } from "antd";
import "./index.less";

interface props {
  dataSource: Array<any>; //數據資料
  columns: Array<any>; //表格配置描述
  pageNoFun?: any; //分页、排序、筛选变化时触发
  pagination?: any; //分頁項目
  defaultExpandAllRows?: boolean; //預設展開表格
  childColumns?: Array<any>; //展開表格
  expandedRowDescriptionFun?: any; //展開表格的補充文字
  subTableName?: any; //展開的標題
  rowSelection?: any;
  tableHeight?: number;
  bordered?: boolean;
  title?: any;
  rowClassName?: any;
  className?: string;
  //參照antd網站

  rowWidth?: number;
  footer?: any;
  fixedRight?: boolean;
  summary?: any;
  displayScrollY?: boolean;
  hasKey?: boolean;
  childrenColumnName?: string;
  components?: any;
  rowKey?: string;
  expandable?: object;
  onRow?: any;
}
interface state {
  dataSource: any;
  uniqueKey: string;
  initTableHeight: number;
}

class ResponsiveTable extends React.Component<props, state> {
  constructor(props: props) {
    super(props);
    this.state = {
      dataSource: [],
      uniqueKey: '',
      initTableHeight: document.body.clientHeight,
    };
  }

  static getDerivedStateFromProps(props: any, state: state) {
    if (props.dataSource && props.dataSource !== state.dataSource) {
      return { ...state, dataSource: props.dataSource };
    }
    return null;
  }

  componentDidMount() {
    this.setState({ uniqueKey: Math.random().toString() });
    window.addEventListener('resize', this.updateSize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateSize);
  }

  updateSize = () => {
    this.setState({ initTableHeight: document.body.clientHeight });
  };

  expandedRowRenderFun = (data: any) => {
    const {
      childColumns = [],
      expandedRowDescriptionFun,
      subTableName,
      title,
    } = this.props;

    const isShowSubTable = childColumns.length > 0;
    return (
      <div className="userManagement-task-table">
        {expandedRowDescriptionFun && expandedRowDescriptionFun(data)}
        {isShowSubTable && subTableName}
        {isShowSubTable && (
          <Table
            title={() => title}
            bordered
            rowKey={(record) => `${record.taskId}-${record.createTime}`}
            columns={childColumns}
            dataSource={data.transaction}
            pagination={false}
            scroll={{ x: "100%" }}
          />
        )}
      </div>
    );
  };

  getWidth = (itemWidth: any) => {
    const { rowWidth } = this.props;
    const defaultWidth = 50;

    return itemWidth || rowWidth || defaultWidth;
  }

  render() {
    const { dataSource, uniqueKey, initTableHeight } = this.state;
    const arr = dataSource || [];
    const {
      columns,
      childColumns,
      expandedRowDescriptionFun,
      rowSelection,
      pageNoFun,
      pagination,
      defaultExpandAllRows,
      tableHeight = initTableHeight - 350,
      footer,
      fixedRight = true,
      summary,
      displayScrollY = true,
      bordered = true,
      hasKey = false,
      childrenColumnName = "children",
      components = '',
      rowKey = 'key',
      expandable = null,
      rowClassName = '',
      onRow = () => {},
      className,
    } = this.props;
    const isShowExpandedRow = !!childColumns || !!expandedRowDescriptionFun;
    const dataSourceNew = arr.map((item: any, index: any) => ({ ...item, key: hasKey ? item.key : `${uniqueKey}-${index}` }));
    const setColumns = columns.map((item: any, index: any) => {
      const columnObject = { ...item, width: this.getWidth(item.width) };
      if (index === columns.length - 1) {
        columnObject.fixed = fixedRight ? "right" : false;
      }
      return columnObject;
    });
    const expandableConfig: any = expandable ? expandable : (isShowExpandedRow ? { expandedRowRender: (record: any) => this.expandedRowRenderFun(record) } : {});
    return (
      <Table
        className={`responsive-table ${className}`}
        bordered={bordered}
        columns={setColumns}
        dataSource={dataSourceNew || []}
        onChange={pageNoFun || undefined}
        pagination={pagination || false}
        scroll={{ x: "max-content", y: displayScrollY ? tableHeight : undefined }}
        defaultExpandAllRows={defaultExpandAllRows || false}
        expandable={expandableConfig}
        rowSelection={rowSelection}
        footer={footer}
        summary={summary}
        showSorterTooltip={false}
        childrenColumnName={childrenColumnName}
        components={components}
        rowKey={rowKey}
        rowClassName={rowClassName}
        onRow={onRow}
      />
    );
  }
}

export default ResponsiveTable;
